module.exports = __webpack_public_path__ + "img/trends_6.0bf491d2.jpg";